var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalMallBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3921_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 4.99992H14.1667C14.1667 2.69992 12.3 0.833252 10 0.833252C7.7 0.833252 5.83333 2.69992 5.83333 4.99992H4.16667C3.25 4.99992 2.50833 5.74992 2.50833 6.66658L2.5 16.6666C2.5 17.5833 3.25 18.3333 4.16667 18.3333H15.8333C16.75 18.3333 17.5 17.5833 17.5 16.6666V6.66658C17.5 5.74992 16.75 4.99992 15.8333 4.99992ZM10 2.49992C11.3833 2.49992 12.5 3.61659 12.5 4.99992H7.5C7.5 3.61659 8.61667 2.49992 10 2.49992ZM10 10.8333C7.7 10.8333 5.83333 8.96659 5.83333 6.66658H7.5C7.5 8.04992 8.61667 9.16658 10 9.16658C11.3833 9.16658 12.5 8.04992 12.5 6.66658H14.1667C14.1667 8.96659 12.3 10.8333 10 10.8333Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3921_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalMallBlack);
export default __webpack_public_path__ + "static/media/local_mall_black.d080be55c6c473496b9d05ab82856b7c.svg";
export { ForwardRef as ReactComponent };